/**
 * One source of truth for the signed-in user's avatar.
 *
 * ATTEST-DEMO-POLISH-1 item 1: the shell drew the same person two different
 * ways — the sidebar took word initials on a gold circle ("Mike S." → "MS"),
 * the header took the first two characters of the whole name on the primary
 * colour ("Mike S." → "MI"). Two avatars, one user, in the same viewport. The
 * initials rule and the colours now live here and both call sites read them,
 * so they cannot drift apart again.
 */

/** Gold disc, navy glyph — the sidebar pair, which was the correct one. */
export const AVATAR_BG = '#c9a227'
export const AVATAR_FG = '#0d1f3c'

/**
 * First letter of each of the first two whitespace-separated words, upper-cased.
 * "Mike S." → "MS"; "Srikanth" → "S"; empty/unknown → "U".
 */
export function userInitials(name?: string | null): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean)
  const initials = words
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase()
  return initials || 'U'
}
